module.exports = __webpack_public_path__ + "static/q5answer2_icecream_wishmas-c1c2d542510f25133f6cf74488311ec8.jpg";